import React, { useState } from 'react';
import styled from 'styled-components';
import translate from '../translations';
import { ICentraCheckoutSelection, IContext, ICentraError } from '../interfaces';
import constants from '../constants';
import { fontSize } from './styles';

const DiscountDiv = styled.div`
    margin-top: 50px;
    margin-bottom: 20px;
`;

const InputFieldDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    width: calc(100% - 25px);
    @media (max-width: ${constants.breakpoints.miniTablet}) {
        width: 100%;
    }
`;

const Label = styled.p`
    margin-top: 0;
    margin-bottom: 10px;
`;

const DiscountInput = styled.input`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 200px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 4px;
    ${fontSize.regular};
    &[type='text'],
    &[type='email'] {
        padding: 0 12px;
    }
`;

const DiscountStatus = styled.div`
    margin-top: 5px;
`;

const SubmitField = styled.input`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 42px;
    min-width: 42px;
    margin-left: 10px;
    border-radius: 4px;
    ${fontSize.regular};
    border: 1.5px solid black;
    border-radius: 4px;
    background: white;
    color: black;
`;

const DeleteDiscountButton = styled.span`
    margin-left: -20px;
    ${fontSize.regular};
    color: #aaaaaa;
    cursor: pointer;
`;

const deleteVouchers = (context: IContext, selection: ICentraCheckoutSelection | undefined) => {
    selection!.discounts.vouchers.forEach(voucher => {
        context.centra.deleteVoucher(voucher.voucher, (errorCode: number, errors: ICentraError) => {
            console.log('error code: ', errorCode);
            console.log('errors', errors);
        });
    });
};

const DiscountField: React.FC<{
    context: IContext;
    selection: ICentraCheckoutSelection | undefined;
    error: string | null;
    onSubmit: Function;
}> = ({ context, selection, error, onSubmit }) => {
    const [inputDiscountCode, setInputDiscountCode] = useState<string | undefined>(
        selection &&
            selection.discounts &&
            selection.discounts.vouchers &&
            selection.discounts.vouchers[0] &&
            selection.discounts.vouchers[0].voucher
    );

    const handleInputDiscountCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputDiscountCode(event.target.value);
    };
    if (
        selection &&
        selection.discounts &&
        selection.discounts.vouchers &&
        selection.discounts.vouchers[0]
    ) {
        return (
            <div>
                <DiscountInput
                    type="text"
                    name="discountCode"
                    value={inputDiscountCode}
                    onChange={handleInputDiscountCode}
                    disabled
                />
                <DeleteDiscountButton onClick={() => deleteVouchers(context, selection)}>
                    x
                </DeleteDiscountButton>
            </div>
        );
    }
    return (
        <div>
            <DiscountInput
                type="text"
                name="discountCode"
                value={inputDiscountCode}
                onChange={handleInputDiscountCode}
                style={
                    error
                        ? {
                              borderColor: constants.colors.pallet.error,
                          }
                        : {}
                }
            />
            <SubmitField
                type="submit"
                value="Ok"
                onClick={e => {
                    e.preventDefault();
                    onSubmit(inputDiscountCode);
                }}
            />
        </div>
    );
};

const Discount: React.FC<{
    context: IContext;
    selection: ICentraCheckoutSelection | undefined;
    language: string;
}> = ({ context, selection, language }) => {
    const [error, setError] = useState<{ [key: string]: string } | null>(null);
    const onSubmit = (discountCode: string) => {
        setError(null);
        context.centra.addVoucher(discountCode, (errorCode: number, errorResult: ICentraError) => {
            console.log('error code: ', errorCode);
            console.log('errors', errorResult);
            setError(errorResult.errors);

            deleteVouchers(context, selection);
        });
    };

    return (
        <DiscountDiv>
            <div>
                <InputFieldDiv>
                    <Label>{translate(language, 'discountString')}</Label>
                    <DiscountField
                        context={context}
                        selection={selection}
                        error={error && error.voucher}
                        onSubmit={onSubmit}
                    />
                </InputFieldDiv>
                <DiscountStatus>
                    {selection &&
                        selection.discounts &&
                        selection.discounts.vouchers &&
                        selection.discounts.vouchers[0] && (
                            <span>{translate(language, 'discountRegistered')}</span>
                        )}
                    {error && error.voucher && error.voucher === 'not found' && (
                        <span>{translate(language, 'discountError')}</span>
                    )}
                </DiscountStatus>
            </div>
        </DiscountDiv>
    );
};

export default Discount;
